import { CardLabel, CheckBox, CitizenInfoLabel, FormStep, Loader, TextInput, TextArea, OpenLinkContainer, BackButton } from "@egovernments/digit-ui-react-components";
import React, { useState } from "react";
import Timeline from "../components/Timeline";

const PermanentAddress = ({ t, config, onSelect, value, userType, formData }) => {
  let validation = {};
  const onSkip = () => onSelect();
  const defaultAddress = {
    address: '',
    state: '',
    district: '',
    tehsil: '',
    town: '',
    pinNo: '',
    university: ''
  };
  const [permanentAddress, setPermanentAddress] = useState({
    ...defaultAddress,
    ...(formData?.LicneseDetails?.PermanentAddress || formData?.formData?.LicneseDetails?.PermanentAddress || {})
  });  
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  let isopenlink = window.location.href.includes("/openlink/");
  const isCitizenUrl = Digit.Utils.browser.isMobile() ? true : false;
  //const isEdit = window.location.href.includes("/edit-application/") || window.location.href.includes("renew-trade");
  //const { isLoading, data: fydata = {} } = Digit.Hooks.tl.useTradeLicenseMDMS(stateId, "egf-master", "FinancialYear");

  //   let mdmsFinancialYear = fydata["egf-master"] ? fydata["egf-master"].FinancialYear.filter(y => y.module === "TL") : [];
  //   let FY = mdmsFinancialYear && mdmsFinancialYear.length > 0 && mdmsFinancialYear.sort((x, y) => y.endingDate - x.endingDate)[0]?.code;

  if(isopenlink)  
  window.onunload = function () {
    sessionStorage.removeItem("Digit.BUILDING_PERMIT");
  }

  const handleAddressChange = (fieldName, value) => {
    setPermanentAddress({
      ...permanentAddress,
      [fieldName]: value
    });
  };
 
  const goNext = () => {

    // sessionStorage.setItem("CurrentFinancialYear", FY);
    if (!(formData?.result && formData?.result?.Licenses[0]?.id)){
      onSelect(config.key, { PermanentAddress: permanentAddress });
    }
    else {
      let data = formData?.formData;
      data.LicneseDetails.PermanentAddress = permanentAddress;
      onSelect("", formData)
    }
  };

  return (
    <React.Fragment>
      <div className={isopenlink ? "OpenlinkContainer" : ""}>

        {isopenlink && <BackButton style={{ border: "none" }}>{t("CS_COMMON_BACK")}</BackButton>}
        <Timeline currentStep={2} flow="STAKEHOLDER" />
        <FormStep
          config={config}
          onSelect={goNext}
          onSkip={onSkip}
          t={t}
          isDisabled={!permanentAddress}
        >
          <CardLabel>{`${t("BPA_PERMANANT_ADDRESS_LABEL")}*`}</CardLabel>
          <TextInput
            t={t}
            isMandatory={false}
            type={"text"}
            optionKey="i18nKey"
            name="permanentAddress"
            onChange={(e) => handleAddressChange('address', e.target.value)}
            value={permanentAddress.address}
          />
          <CardLabel>{`${t("CORE_COMMON_STATE")}`}</CardLabel>
          <TextInput
            t={t}
            isMandatory={false}
            type={"text"}
            optionKey="i18nKey"
            name="state"
            onChange={(e) => handleAddressChange('state', e.target.value)}
            value={permanentAddress.state}
          />
          <CardLabel>{`${t("CORE_COMMON_DISTRICT")}`}</CardLabel>
          <TextInput
            t={t}
            isMandatory={false}
            type={"text"}
            optionKey="i18nKey"
            name="district"
            onChange={(e) => handleAddressChange('district', e.target.value)}
            value={permanentAddress.district}
          />
          <CardLabel>{`${t("CORE_COMMON_TEHSIL")}`}</CardLabel>
          <TextInput
            t={t}
            isMandatory={false}
            type={"text"}
            optionKey="i18nKey"
            name="tehsil"
            onChange={(e) => handleAddressChange('tehsil', e.target.value)}
            value={permanentAddress.tehsil}
          />
          <CardLabel>{`${t("CORE_COMMON_TOWN")}`}</CardLabel>
          <TextInput
            t={t}
            isMandatory={false}
            type={"text"}
            optionKey="i18nKey"
            name="town"
            onChange={(e) => handleAddressChange('town', e.target.value)}
            value={permanentAddress.town}
          />
          <CardLabel>{`${t("CORE_COMMON_PINNO")}`}</CardLabel>
          <TextInput
            t={t}
            isMandatory={false}
            type={"text"}
            optionKey="i18nKey"
            name="pinNo"
            onChange={(e) => handleAddressChange('pinNo', e.target.value)}
            value={permanentAddress.pinNo}
          />
          <CardLabel>{`${t("CORE_COMMON_UNIVERSITY_NAME")}`}</CardLabel>
          <TextInput
            t={t}
            isMandatory={false}
            type={"text"}
            optionKey="i18nKey"
            name="university"
            onChange={(e) => handleAddressChange('university', e.target.value)}
            value={permanentAddress.university}
          />
        </FormStep>
      </div>
    </React.Fragment>
  );
};

export default PermanentAddress;